// Google Analytics 4 & Facebook Pixel Event Tracking Utility

// Check if gtag is available
const isGtagAvailable = () => {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
};

// Check if Facebook Pixel is available
const isFbqAvailable = () => {
  return typeof window !== 'undefined' && typeof window.fbq === 'function';
};

// Track custom events - GA4
export const trackEvent = (eventName, eventParams = {}) => {
  if (isGtagAvailable()) {
    window.gtag('event', eventName, eventParams);
    console.log(`[GA4] Event tracked: ${eventName}`, eventParams);
  }
};

// Track Facebook Pixel events
export const trackFbEvent = (eventName, eventParams = {}) => {
  if (isFbqAvailable()) {
    window.fbq('track', eventName, eventParams);
    console.log(`[FB Pixel] Event tracked: ${eventName}`, eventParams);
  }
};

// Pre-defined events for Abba Academy

// Track when user submits enquiry form
export const trackEnquirySubmit = (pricingOption, studentTier) => {
  const value = pricingOption === 'monthly' ? 99.99 : pricingOption === 'vip' ? 65.00 : 29.99;
  
  // GA4 Event
  trackEvent('generate_lead', {
    currency: 'GBP',
    value: value,
    pricing_option: pricingOption,
    student_tier: studentTier
  });
  
  // Facebook Pixel Event
  trackFbEvent('Lead', {
    currency: 'GBP',
    value: value,
    content_name: pricingOption === 'monthly' ? 'Monthly Package' : pricingOption === 'vip' ? 'VIP 1-on-1' : 'One-Off Lesson',
    content_category: 'GCSE Maths Tuition'
  });
};

// Track when user clicks "Book a Session" button
export const trackBookSessionClick = (location) => {
  // GA4 Event
  trackEvent('begin_checkout', {
    currency: 'GBP',
    items: [{
      item_name: 'GCSE Maths Tuition',
      item_category: 'Education'
    }],
    click_location: location
  });
  
  // Facebook Pixel Event
  trackFbEvent('InitiateCheckout', {
    content_category: 'GCSE Maths Tuition',
    content_name: 'Book Session Click'
  });
};

// Track when user clicks Calendly "Schedule Free Call"
export const trackCalendlyClick = (location) => {
  // GA4 Event
  trackEvent('schedule_call', {
    method: 'calendly',
    click_location: location
  });
  
  // Facebook Pixel Event
  trackFbEvent('Schedule', {
    content_name: 'Free Consultation Call',
    content_category: 'Calendly Booking'
  });
};

// Track payment initiation
export const trackPaymentStart = (amount, pricingOption) => {
  // GA4 Event
  trackEvent('begin_checkout', {
    currency: 'GBP',
    value: amount / 100, // Convert from pence to pounds
    items: [{
      item_name: pricingOption === 'monthly' ? 'Monthly Package' : pricingOption === 'vip' ? 'VIP 1-on-1' : 'One-Off Lesson',
      price: amount / 100,
      quantity: 1
    }]
  });
  
  // Facebook Pixel Event
  trackFbEvent('InitiateCheckout', {
    currency: 'GBP',
    value: amount / 100,
    content_name: pricingOption === 'monthly' ? 'Monthly Package' : pricingOption === 'vip' ? 'VIP 1-on-1' : 'One-Off Lesson',
    content_category: 'GCSE Maths Tuition',
    content_type: 'product',
    num_items: 1
  });
};

// Track successful payment
export const trackPaymentSuccess = (amount, pricingOption, enquiryId) => {
  // GA4 Event
  trackEvent('purchase', {
    transaction_id: enquiryId,
    currency: 'GBP',
    value: amount / 100,
    items: [{
      item_name: pricingOption === 'monthly' ? 'Monthly Package' : pricingOption === 'vip' ? 'VIP 1-on-1' : 'One-Off Lesson',
      price: amount / 100,
      quantity: 1
    }]
  });
  
  // Facebook Pixel Event
  trackFbEvent('Purchase', {
    currency: 'GBP',
    value: amount / 100,
    content_name: pricingOption === 'monthly' ? 'Monthly Package' : pricingOption === 'vip' ? 'VIP 1-on-1' : 'One-Off Lesson',
    content_category: 'GCSE Maths Tuition',
    content_type: 'product',
    content_ids: [enquiryId],
    num_items: 1
  });
};

// Track video plays
export const trackVideoPlay = (videoTitle, platform) => {
  trackEvent('video_start', {
    video_title: videoTitle,
    video_provider: platform
  });
  
  trackFbEvent('ViewContent', {
    content_name: videoTitle,
    content_category: 'Video',
    content_type: platform
  });
};

// Track TikTok link clicks
export const trackTikTokClick = () => {
  trackEvent('click', {
    link_type: 'social',
    platform: 'tiktok',
    link_url: 'https://www.tiktok.com/@drmichaelomakobia'
  });
};

// Track phone call clicks
export const trackPhoneClick = () => {
  trackEvent('click', {
    link_type: 'phone',
    phone_number: '+447948213565'
  });
  
  trackFbEvent('Contact', {
    content_name: 'Phone Call',
    content_category: 'Contact'
  });
};

// Track email clicks
export const trackEmailClick = () => {
  trackEvent('click', {
    link_type: 'email',
    email: 'drmomakobia@abbaacademy.com'
  });
  
  trackFbEvent('Contact', {
    content_name: 'Email',
    content_category: 'Contact'
  });
};

// Track page views (called automatically by GA4, but can be used for SPA navigation)
export const trackPageView = (pagePath, pageTitle) => {
  if (isGtagAvailable()) {
    window.gtag('config', 'G-CDC91Y8Q83', {
      page_path: pagePath,
      page_title: pageTitle
    });
  }
  
  // Facebook Pixel tracks PageView automatically, but we can trigger it manually for SPA
  if (isFbqAvailable()) {
    window.fbq('track', 'PageView');
  }
};
